import { Measure, isRecentlyChangedMeasureCode } from 'services/model/model.service';

export function isRecentlyChangedMeasure(measure: Measure): boolean {
  return isRecentlyChangedMeasureCode(measure.code);
}
